import React, { createContext, PropsWithChildren, ReactNode, Reducer, useReducer } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteNameEnum } from '~/types/common';
import AppContextProvider from '../../AppContext';
import LayoutDefault from './LayoutDefault';
import LayoutMonitoring from './LayoutMonitoring';

interface ILayoutContext {
  title: ReactNode;
  tabs?: JSX.Element;
  description?: JSX.Element;
  stickyHeader?: JSX.Element;
  brandUnselectable?: boolean;
  renderTabs?: () => ReactNode;
  renderCompactTabs: () => ReactNode;
  renderFixedPanel: () => ReactNode;
  renderActionButton?: () => ReactNode;
  renderMenuButton?: () => ReactNode;
  renderControls?: () => ReactNode;
}

interface IProps {}

const defaultValue = {
  title: '',
  renderTabs: () => undefined,
  renderCompactTabs: () => undefined,
  renderFixedPanel: () => undefined,
};

export const LayoutWrapperContext = createContext<[ILayoutContext, React.Dispatch<Partial<ILayoutContext>>]>([
  defaultValue,
  () => null,
]);

const LayoutWrapper = (props: PropsWithChildren<IProps>): JSX.Element => {
  const {pathname} = useLocation();

  const [state, setState] = useReducer<Reducer<ILayoutContext, Partial<ILayoutContext>>>(
    (state, partialState) => ({ ...defaultValue, ...partialState }),
    defaultValue
  );

  const Layout = (() => {
    switch (pathname) {
      case RouteNameEnum.Enforcement:
        return LayoutMonitoring;
      case '/':
      case '/login':
        return function layout(props: React.PropsWithChildren<IProps>) {
          return <>{props.children}</>;
        };
      default:
        return LayoutDefault;
    }
  })();

  return (
    <AppContextProvider>
      <LayoutWrapperContext.Provider value={[state, setState]}>
        <Layout>{props.children}</Layout>
      </LayoutWrapperContext.Provider>
    </AppContextProvider>
  );
};

export default LayoutWrapper;